import { FormControl, FormLabel, TextField } from '@mui/material';
import HelpTooltip from '../HelpTooltip';
import { BiHelpCircle } from 'react-icons/bi';
import FieldLock from '../FieldLock';

export interface InputFieldProps {
    labelText: string;
    labelId: string;
    mandatory: boolean;
    helpTextTitle: string;
    helpTextBody: string;
    onChange: (value: string) => void;
    onBlur: (value: string) => void;
    disabled: boolean;
    fullWidth: boolean
    value: string | number | boolean;
    error: boolean;
    helperText?: string;
    rows?: number;
    type?: string;

    onLock: (field: string, locked: boolean) => void;
    disabledLock: boolean;
    displayedLock: boolean;
    isLocked: boolean;
}

const InputField = (props: InputFieldProps): JSX.Element => {

    const handleOnBlur = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        props.onBlur(event.target.value);
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = event.target.value;
        if(value.startsWith('0') && value.length > 1){
            const newValue = value.substring(1);
            props.onChange( newValue );
        } else {
            props.onChange( value);
        }
    };

    const totalRows = props.rows || 1;
    const multiLine = totalRows > 1;

    return (
        <FormControl fullWidth={props.fullWidth}>
        <FormLabel component="legend" sx={{fontSize:'12px', mb:'0.1'}} htmlFor={props.labelId}>
            <FieldLock
                onChange={function (locked: boolean): void {
                    props.onLock(props.labelId,locked);
                } }
                labelId={props.labelId}
                disabled={props.disabledLock}
                displayed={props.displayedLock}
                value={props.isLocked}/>
         {props.labelText} <b>{props.mandatory ? '*' : ''}</b> <HelpTooltip title={props.helpTextTitle} body={props.helpTextBody}> <BiHelpCircle/> </HelpTooltip>
        </FormLabel>
        <TextField
            sx={{bgcolor:'#FFFFFF', marginTop:'15px'}}
            fullWidth={props.fullWidth}
            id={props.labelId}
            data-testid={props.labelId}
            onChange={handleInputChange}
            value={props.value?.toString()}
            onBlur={handleOnBlur}
            disabled={props.disabled}
            error={props.error}
            helperText={props.helperText || ''}
            margin="dense"
            rows={totalRows}
            multiline={multiLine}
            type={props.type || 'text'}
            inputMode={props.type ? 'numeric' : 'text'}
            InputProps={ !multiLine ? {
                sx: {
                  height: '50px',
                  '& input': {
                    height: '50px',
                    padding: '0 14px',
                    boxSizing: 'border-box',
                  },
                },
            }: {}}
      />
      </FormControl>
    );
  };

export default InputField;